<div
    [id]="form.displayId()"
    class="text-root"
    [style.--text-justify]="rootJustify()"
    [style.--text-transform]="rootTransform()"
    [style.--text-transform-mobile]="rootTransformMobile()"
    [style.--text-transform-tablet]="rootTransformTablet()"
    [style.--text-z-index]="rootZIndex()"
    [style.--text-z-index-mobile]="rootZIndexMobile()"
    [style.--text-z-index-tablet]="rootZIndexTablet()"
>
    <div
        #animatedElem
        class="sp-ui-text text-content"
        [style.--text-width]="contentWidth()"
        [style.--text-width-mobile]="contentWidthMobile()"
        [style.--text-width-tablet]="contentWidthTablet()"
    >
        <web-editor
            [containerId]="widgetIdWithPrefix()"
            [content]="form.content().value()"
            [widgetId]="form.id().value()"
            [useExperimentalFocus]="true"
            [useExperimentalDblClickFocus]="isZeroSig()"
            (changeContent)="form.setContent($event)"
            (focusInEvent)="onFocus(form.id().value())"
        />
    </div>
</div>
